import SiteLayout from "@/components/feature/SiteLayout";
import Seo from "@/components/seo/Seo";
import { SITE_ORIGIN } from "@/lib/leaks";
import { faqs, site } from "@/mocks/site";
import { leaks } from "@/mocks/leaks";
import Hero from "@/pages/home/components/Hero";
import FlashTicker from "@/pages/home/components/FlashTicker";
import LatestSection from "@/pages/home/components/LatestSection";
import TopicSection from "@/pages/home/components/TopicSection";
import HotSection from "@/pages/home/components/HotSection";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqSection from "@/pages/home/components/FaqSection";
import BrandCta from "@/pages/home/components/BrandCta";

export default function Home() {
  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: site.name,
      url: SITE_ORIGIN,
      description: site.intro,
      potentialAction: {
        "@type": "SearchAction",
        target: `${SITE_ORIGIN}/feed?q={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: site.name,
      url: SITE_ORIGIN,
      slogan: site.slogan,
      email: site.email,
      description: site.mission,
    },
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "蝌蚪爆料最新爆料",
      itemListElement: leaks.slice(0, 6).map((leak, index) => ({
        "@type": "ListItem",
        position: index + 1,
        url: `${SITE_ORIGIN}/leak/${leak.id}`,
        name: leak.title,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ];

  return (
    <SiteLayout>
      <Seo
        title="蝌蚪爆料 | 蝌蚪爆料最新现场快讯抢先知"
        description="蝌蚪爆料抢先看首发，最新现场快讯每天更新，一手消息不间断，满足第一时间掌握爆料动态的吃瓜需求。"
        keywords="蝌蚪爆料,蝌蚪爆料最新,蝌蚪爆料首发,蝌蚪爆料快讯,蝌蚪爆料现场"
        path="/"
        jsonLd={jsonLd}
      />
      <Hero />
      <FlashTicker />
      <LatestSection />
      <TopicSection />
      <HotSection />
      <Testimonials />
      <FaqSection />
      <BrandCta />
    </SiteLayout>
  );
}